import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectVideo } from 'widget/redux/client/actions/select-video';
import { playVideo, pauseVideo } from 'widget/redux/client/actions/player/change-playback-status';
import { getCurrentSiteUser } from 'widget/selectors/current-site-user';
import { getChannelForWidget } from '@wix/wix-vod-shared/src/common/selectors/channels';
import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { canPlayFullOrPreview } from '@wix/wix-vod-shared/src/widget/ui-selectors/video-access';
import { getVideoCardsList } from 'widget/selectors/video-cards';
import VideoCardsWrapper from 'widget/components/video-cards-wrapper/video-cards-wrapper';

@connect(
  state => ({
    cardsData: getVideoCardsList(state),
    currentSiteUser: getCurrentSiteUser(state),
    videoByIds: getVideosGroupedByIds(state),
    channelData: getChannelForWidget(state),
  }), {
    selectVideo,
    playVideo,
    pauseVideo,
  })
export default class VideoCardsWrapperDesktop extends React.PureComponent {
  static propTypes = {
    currentSiteUser: PropTypes.object,
    channelData: PropTypes.object,
    videoByIds: PropTypes.object,
    cardsData: PropTypes.array,

    children: PropTypes.func.isRequired,

    selectVideo: PropTypes.func,
    playVideo: PropTypes.func,
    pauseVideo: PropTypes.func,

    thumbnailSize: PropTypes.number,
  };

  @autobind
  handlePlayRequest({ id }) {
    const { videoByIds, channelData, currentSiteUser, selectVideo, playVideo } = this.props;
    const videoItem = videoByIds[id];
    const isPlayAllowed = canPlayFullOrPreview(channelData, videoItem, currentSiteUser);

    if (isPlayAllowed) {
      playVideo(videoItem.id);
      return;
    }

    selectVideo(videoItem.id);
  }

  render() {
    return (
      <VideoCardsWrapper {...this.props}
                         handlePlayRequest={this.handlePlayRequest} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/components/video-cards-wrapper-desktop/video-cards-wrapper-desktop.js